export default "__VITE_ASSET__87ca5ddb__"